import React from 'react';
import { Facebook, Twitter, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black border-t border-gold-500/30 pt-16 pb-8" data-id="element-60">
      <div className="container mx-auto px-4" data-id="element-61">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-62">
          <div className="col-span-1 md:col-span-2" data-id="element-63">
            <h2 className="text-gold-500 font-serif text-2xl mb-4" data-id="element-64">
              SGLonelyGuy
            </h2>
            <p className="text-gray-500 max-w-sm mb-6" data-id="element-65">
              新加坡首选的高端伴游服务平台。致力于为都市精英提供私密、安全、高品质的社交体验。
            </p>
            <div className="flex space-x-4" data-id="element-66">
              <a href="#" className="text-gray-500 hover:text-gold-500 transition-colors" data-id="element-67">
                <Facebook className="w-5 h-5" data-id="element-68" />
              </a>
              <a href="#" className="text-gray-500 hover:text-gold-500 transition-colors" data-id="element-69">
                <Twitter className="w-5 h-5" data-id="element-70" />
              </a>
              <a href="#" className="text-gray-500 hover:text-gold-500 transition-colors" data-id="element-71">
                <Instagram className="w-5 h-5" data-id="element-72" />
              </a>
            </div>
          </div>

          <div data-id="element-73">
            <h3 className="text-white font-medium mb-4 uppercase tracking-wider text-sm" data-id="element-74">
              快速链接
            </h3>
            <ul className="space-y-2" data-id="element-75">
              <li data-id="element-76">
                <a href="#" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-77">
                  关于我们
                </a>
              </li>
              <li data-id="element-78">
                <a href="#" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-79">
                  服务项目
                </a>
              </li>
              <li data-id="element-80">
                <a href="#" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-81">
                  精选伴游
                </a>
              </li>
              <li data-id="element-82">
                <a href="#" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-83">
                  会员权益
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-84">
            <h3 className="text-white font-medium mb-4 uppercase tracking-wider text-sm" data-id="element-85">
              法律信息
            </h3>
            <ul className="space-y-2" data-id="element-86">
              <li data-id="element-87">
                <a href="#" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-88">
                  使用条款
                </a>
              </li>
              <li data-id="element-89">
                <a href="#" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-90">
                  隐私政策
                </a>
              </li>
              <li data-id="element-91">
                <a href="#" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-92">
                  免责声明
                </a>
              </li>
              <li data-id="element-93">
                <a href="#" className="text-gray-500 hover:text-gold-500 transition-colors text-sm" data-id="element-94">
                  联系我们
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-95">
          <p className="text-gray-600 text-xs mb-4 md:mb-0" data-id="element-96">
            &copy; {new Date().getFullYear()} SGLonelyGuy. All rights reserved.
          </p>
          <div className="flex items-center gap-2 text-gray-600 text-xs border border-white/10 px-3 py-1 rounded" data-id="element-97">
            <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse" data-id="element-98"></span>
            <span data-id="element-99">Adults Only 18+</span>
          </div>
        </div>
      </div>
    </footer>;
}